import { ApplicationRef, ComponentRef, inject, Injectable, Type } from '@angular/core';

import { Subject } from 'rxjs';

import { Modal, ModalUtil } from '@models/index';

@Injectable()
export class ModalBuilderService {
    private readonly appRef = inject(ApplicationRef);

    /**
     * @NzModalService To use modal confirm, use NzModalService directly
     */
    open<T extends Modal<any, any>>(component: Type<T>, inputs?: any, autoDestroy$?: Subject<boolean>): ModalUtil<any> {
        const modalContainer = document.createElement('div');
        document.getElementsByTagName('body')[0].appendChild(modalContainer);
        const componentRef: ComponentRef<T> = this.appRef.bootstrap(component, modalContainer);
        componentRef.instance.onInjectInputs(inputs);
        componentRef.instance.openModal();
        // Ensure OnPush components reflect state changes immediately
        componentRef.changeDetectorRef.markForCheck();
        componentRef.changeDetectorRef.detectChanges();

        return new ModalUtil(componentRef, autoDestroy$);
    }
}
